<template>
  <LayoutBase
    class="layout-jps jps"
    :class="{
      'layout-jps-default-margin-top': route.meta.disableDefaultMargin !== true && route.meta.disableDefaultMargin?.top !== true,
      'layout-jps-default-margin-bottom': route.meta.disableDefaultMargin !== true && route.meta.disableDefaultMargin?.bottom !== true,
    }"
  >
    <template #header>
      <GlobalJpsHeader />
    </template>
    <template
      v-if="breadcrumbs && breadcrumbs.length"
      #breadcrumbs
    >
      <GlobalJpsBreadcrumbs
        :breadcrumbs="breadcrumbs"
      />
    </template>
    <slot />
    <template #footer v-if="!route.meta.disableFooter">
      <GlobalJpsFooter />
    </template>
  </LayoutBase>
</template>

<script lang="ts" setup>
const route = useRoute()
const pageStore = usePageStore()
const breadcrumbs = computed(() => {
  return pageStore.current?.breadcrumbs
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.layout-jps-default-margin-top {
  :deep(#main) {
    padding-top: calc(0.25rem * 4);
    @include is-tablet {
      padding-top: calc(0.25rem * 12);
    }
  }
}

.layout-jps-default-margin-bottom {
  :deep(#main) {
    padding-bottom: calc(0.25rem * 4);
    @include is-tablet {
      padding-bottom: calc(0.25rem * 12);
    }
  }
}
</style>
